module.exports = __webpack_public_path__ + "media/images/responsive/flow/yoso_step02-d80c26b1ceb44e1f9dddf3dc7f588fa4.jpg";